var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      attrs: { active: "", "has-modal-card": "" },
      on: {
        close: function() {
          return _vm.$router.push({ name: "NewSalaryReceipt" })
        }
      }
    },
    [
      _c(
        "form",
        {
          staticClass: "modal-card",
          staticStyle: { width: "auto" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.create($event)
            }
          }
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title has-text-primary" }, [
              _vm._v("\n        Crear nuevo empleado\n      ")
            ])
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [_c("NewBasicEmployee", { attrs: { loading: _vm.loading } })],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "button",
                  attrs: { to: { name: "NewSalaryReceipt" } }
                },
                [_vm._v("\n        Cerrar\n      ")]
              ),
              _c(
                "button",
                { staticClass: "button is-primary", attrs: { type: "submit" } },
                [_vm._v("\n        Crear empleado\n      ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }